import { render } from "./DetailedEmpView.vue?vue&type=template&id=18fc8beb&scoped=true"
import script from "./DetailedEmpView.vue?vue&type=script&lang=js"
export * from "./DetailedEmpView.vue?vue&type=script&lang=js"

import "./DetailedEmpView.vue?vue&type=style&index=0&id=18fc8beb&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18fc8beb"]])

export default __exports__